import * as React from "react";
import { format, parseISO } from "date-fns";

/*
**  DatePicker values are dates in the user's locale
**  Values selected are a pair [startDate, endDate]
**  Built with native HTML5 date inputs - no MUI Pro license required
*/

function toInputValue(date) {
  if (!date) return "";
  const d = date instanceof Date ? date : new Date(date);
  return format(d, "yyyy-MM-dd");
}

function parseInputValue(value) {
  if (!value) return null;
  try {
    return parseISO(value);
  } catch {
    return null;
  }
}

export default function DatePicker({ value, setValue }) {
  const [start, end] = Array.isArray(value) ? value : [value, null];
  const effectiveEnd = end || start;
  const startStr = toInputValue(start);
  const endStr = toInputValue(effectiveEnd);

  const handleStartChange = (e) => {
    const newStart = parseInputValue(e.target.value);
    if (newStart) {
      const currentEnd = end || start;
      const newEnd =
        currentEnd && currentEnd >= newStart ? currentEnd : newStart;
      setValue([newStart, newEnd]);
    }
  };

  const handleEndChange = (e) => {
    const newEnd = parseInputValue(e.target.value);
    if (newEnd) {
      const newStart = start || newEnd;
      setValue([newStart, newEnd >= newStart ? newEnd : newStart]);
    }
  };

  const today = format(new Date(), "yyyy-MM-dd");

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        marginRight: 10,
        gap: 8,
      }}
    >
      <label style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <span style={{ fontSize: 14, color: "#666" }}>From</span>
        <input
          type="date"
          value={startStr}
          onChange={handleStartChange}
          max={today}
          style={{
            padding: "6px 10px",
            fontSize: 14,
            border: "1px solid rgba(0,0,0,0.23)",
            borderRadius: 4,
            outline: "none",
          }}
        />
      </label>
      <label style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <span style={{ fontSize: 14, color: "#666" }}>To</span>
        <input
          type="date"
          value={endStr}
          onChange={handleEndChange}
          min={startStr || undefined}
          max={today}
          style={{
            padding: "6px 10px",
            fontSize: 14,
            border: "1px solid rgba(0,0,0,0.23)",
            borderRadius: 4,
            outline: "none",
          }}
        />
      </label>
    </div>
  );
}
